import styled from 'styled-components';
import { container } from '../../styles/mixins';

export const MenuItem = styled.div`
  ${container()}
  margin-top: 50px;
  padding-bottom: 50px;
`;



// WEBPACK FOOTER //
// ./src/screens/Menu/style.js